var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"300px"},attrs:{"src":_vm.imgSrc}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }